import { render, staticRenderFns } from "./ProductSpecsEdit.vue?vue&type=template&id=37426a8e"
import script from "./ProductSpecsEdit.vue?vue&type=script&lang=js"
export * from "./ProductSpecsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37426a8e')) {
      api.createRecord('37426a8e', component.options)
    } else {
      api.reload('37426a8e', component.options)
    }
    module.hot.accept("./ProductSpecsEdit.vue?vue&type=template&id=37426a8e", function () {
      api.rerender('37426a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ProductSpecsEdit.vue"
export default component.exports